import { useState, useEffect } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody, Textarea, Autocomplete, AutocompleteItem } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/itemGroupEntrySlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { ReportTemplateComponents, TemplateReportType } from "../report/ReportUtility";



const CreateItemGroupEntry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode } = useSelector((state) => state.company);

    const [tempNameData, setTempNameData] = useState([])
    const { detailParams, isNewEntry } = useSelector((state) => state.reportTemplate);

    const [formData, setFormData] = useState({
        tempCode: "",
        tempName: "",
        reportType: "",
        terms: "",
    });


    const { data: detail = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.reportTemplate.fetchEntryDetail,
        queryKey: "fetchItemGroupdetail",
    });

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    compcode: compCode.join(","),
                    rpt_type: detailParams.rpt_type
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && detail && detail.length > 0) {
            const d = ReportTemplateComponents.filter((ele => ele.key == detail[0].ReportType))
            setTempNameData(d[0].data)
            setFormData({
                tempCode: detail[0].TempCode || "",
                tempName: detail[0].TempName || "",
                reportType: detail[0].ReportType || "",
                terms: detail[0].Terms || "",
            });
            // console.log(shapeDetails.S_Code, isNewEntry, formData)

        }
    }, [detail]);



    const handleAutoCompleteChange = (val, name) => {

        let temp_name = formData.tempName
        if (name == "tempCode") {
            const filData = tempNameData.filter((ele) => ele.Code == val)
            if (filData && filData.length > 0)
                temp_name = filData[0].Name
        }
        setFormData({ ...formData, [name]: val, tempName: temp_name });
        if (name == "reportType") {
            const d = ReportTemplateComponents.filter((ele => ele.key == val))
            setTempNameData(d[0].data)
        }
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "TemplateAddUpdate",
        url: apiRoute.reportTemplate.add_update,
        onSuccessTasks: () => {
            dispatch(resetDetailParams());
            navigate(linksUrl.reportTemplate.templateMaster);
        },
    });




    const handleSubmit = (e) => {
        e.preventDefault();
        funAddUpdate({
            data: {
                compcode: compCode.join(","),
                tempcode: formData.tempCode,
                tempname: formData.tempName,
                rpttype: formData.reportType,
                terms: formData.terms,
                login_userid: user.username,
                rec_status: !isNewEntry ? 1 : 2,
            }
        });

    };



    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Report Templates"
            breadcrumbs={["Setting", "Report Templates"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.reportTemplate.templateMaster) }}
        >
            {/* <Card className="p-6"> */}
            <Card shadow="sm" radius="sm" className="mb-3  h-[calc(100vh-118px)]  overflow-y-auto">

                <form onSubmit={handleSubmit}>
                    <CardBody>
                        <div className="grid gap-4">
                            <Autocomplete
                                size="md"
                                name={"reportType"}
                                //isInvalid={errors["reportType"]}
                                // errorMessage={errors["reportType"]}
                                label={"Report Type"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={"Report Type"}
                                isRequired
                                className="max-w-23"
                                classNames={{
                                    label: "text-xs text-black font-bold",
                                }}
                                isClearable={false}
                                isVirtualized
                                defaultItems={
                                    TemplateReportType || []
                                }
                                onSelectionChange={(e) =>
                                    handleAutoCompleteChange(e, "reportType")
                                }
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData.reportType}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.key}
                                    >
                                        {list.key}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>

                            <Autocomplete
                                size="md"
                                name={"tempCode"}
                                // isInvalid={errors["tempCode"]}
                                // errorMessage={errors["tempCode"]}
                                label={"Template"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={"Template Name"}
                                isRequired
                                className="max-w-23"
                                classNames={{
                                    label: "text-xs text-black font-bold",
                                }}
                                isClearable={false}
                                isVirtualized
                                defaultItems={
                                    tempNameData || []
                                }
                                onSelectionChange={(e) =>
                                    handleAutoCompleteChange(e, "tempCode")
                                }
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData.tempCode}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.Code}
                                    >
                                        {list.Name}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                            <Textarea
                                type="text"
                                name={"terms"}
                                placeholder={"Terms & Condition "}
                                label={"Terms & Condition "}
                                labelPlacement="outside"
                                variant="bordered"
                                classNames={{
                                    label: "text-xs text-black font-bold",
                                }}
                                value={formData.terms}
                                size={"md"}
                                onChange={(e) => handleAutoCompleteChange(e.target.value, "terms")}
                            >

                            </Textarea>

                            <div className="flex gap-4 items-center justify-center">
                                <Button type="submit" id="btnSave" color="primary" size="sm" isLoading={isPending}>
                                    {isNewEntry ? "Save" : "Update"}
                                </Button>

                                <Button size="sm" onPress={() => navigate(linksUrl.reportTemplate.templateMaster)} color="danger" isLoading={isPending}>
                                    Cancle
                                </Button>
                            </div>
                        </div>
                    </CardBody>
                </form>




            </Card>
        </MainContainer>
    );
};

export default CreateItemGroupEntry;

